<template>
    <div class="text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="aside-box" v-else-if="standings.length > 2">
        <template v-for="(group_standing,key) in group_standings">
            <strong class="h2 text-uppercase">Standings {{ Object.keys(group_standings).length > 1 ? '('+key+')' : '' }}</strong>
            <ul class="standings-list">
                <li class="head">
                    <span class="standing-title">team</span>
                    <span class="points">PTS</span>
                </li>
                <li :class="{ highlight: teams.includes(standing.team_id) }" v-for="standing in group_standing.items" :key="standing.id">
            <router-link :to="{ name: 'teamDetail.Matches', params: { tournament: standing.tournament.slug, team: standing.team.slug } }" class="standings-link">
                <span class="standing-title">{{ standing.position }}. {{ standing.team_name }}</span>
                <span class="points">{{ standing.points }}</span>
            </router-link>
            </li>
        </ul>
    </template>
</div>
</template>

<script>
    import collect from 'collect.js';
    export default {
        name: 'matchStandings',

        data() {
            return {
                standings: [],
                teams: []
            }
        },
        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return

                
                
                let teams = []
                this.standings.forEach((standing) => {
                teams.push(
                        {
                            "@type": "SportsTeam",
                            "name": standing.team.name,
                            logo: standing.team.flag,
                              "location": {
                            "@type": "Place",
                            "name": standing.team.name + ", " + standing.team.country,
                            "address": {
                            "@type": "PostalAddress",
                            "name": standing.team.name + ", " + standing.team.country,
                            }
                }
                        }
                )
            });
                return {   
                "@context": "http://schema.org",
                "@graph": teams
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
        },
        methods: {
            main() {
                return this.$axios
                        .get(this.$MATCH_STANDINGS_API.replace(':match', this.$route.params.match))
                        .then(response => {
                            this.is_data_ready = true
                            this.standings = response.data.result.standings || []
                            this.teams = response.data.result.teams || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            }},
        computed: {
            group_standings() {
                return collect(this.standings).groupBy('group').sortKeys().all();
            }
        },
    }
</script>

